import React from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ChipCard } from 'assets/icons/circles/ChipCard'

import { ESim } from '../../../../assets/icons/circles/eSIM'
import TabbedPage from '../../../../common/TabbedPage'

import ESimOrderManagementPage from './subpages/ESimOrderManagementPage'
import PhysicalSimOrderManagement from './subpages/PhysicalSimOrderManagement'

let toggledWarningFromPrevLocation = false

interface LocationState {
  reason?: string | undefined
}

const OrderManagementSubtabs = [
  { label: 'Physical SIM', icon: <ChipCard /> },
  { label: 'ESIM', icon: <ESim /> }
]

const pageHeader = 'Manage Orders'

const tabPanels = [
  {
    key: `OrderManagementPage-physicalSimTab`,
    element: <PhysicalSimOrderManagement />
  },
  {
    key: `OrderManagementPage-ESimTab`,
    element: <ESimOrderManagementPage />
  }
]

export default function OrderManagementPage() {
  // reads the redirect error and toasts it to the client
  const location = useLocation()
  const state = location.state as LocationState
  if (state?.reason && !toggledWarningFromPrevLocation) {
    toggledWarningFromPrevLocation = true
    toast.error(state.reason)
    delete state.reason
  }

  return (
    <TabbedPage
      subTabs={OrderManagementSubtabs}
      pageHeader={pageHeader}
      tabPanels={tabPanels}
    />
  )
}
